import styled from "styled-components";
import usePwaInstall from "../hooks/usePwaInstall";
import { useLanguage } from "../contexts/LanguageContext";

const InstallBanner = () => {
  const { t } = useLanguage();
  const { showBanner, isIos, showIosHelp, promptInstall, dismiss } =
    usePwaInstall();

  if (!showBanner) return null;

  return (
    <Bar role="region" aria-label={t("ban.aria")}>
      <Mark src="/icons/icon-192.png" alt="" />
      <Copy>
        <strong>{t("ban.title")}</strong>
        <span>
          {showIosHelp && isIos
            ? t("ban.ios")
            : showIosHelp
              ? t("ban.chrome")
              : isIos
                ? t("ban.add")
                : t("ban.icon")}
        </span>
      </Copy>
      <Buttons>
        <Primary type="button" onClick={promptInstall}>
          {t("ban.install")}
        </Primary>
        <Ghost type="button" onClick={dismiss}>
          {t("ban.later")}
        </Ghost>
      </Buttons>
    </Bar>
  );
};

export default InstallBanner;

const Bar = styled.div`
  position: fixed;
  left: 16px;
  right: 16px;
  transform: none;
  width: auto;
  max-width: 480px;
  margin: 0 auto;
  bottom: calc(var(--tabbar-h) + 10px);
  z-index: 45;
  display: grid;
  grid-template-columns: 40px 1fr auto;
  align-items: center;
  gap: 10px;
  padding: 12px;
  background: var(--surface);
  border: 1px solid var(--line);
  border-radius: 16px;
  box-shadow: var(--shadow-soft);
`;

const Mark = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 10px;
  object-fit: cover;
`;

const Copy = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
  color: var(--ink);

  strong {
    font-size: 14px;
    font-weight: 700;
  }

  span {
    font-size: 12px;
    color: var(--ink-soft);
    line-height: 1.3;
  }
`;

const Buttons = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 4px;
`;

const Primary = styled.button`
  border: none;
  border-radius: 8px;
  padding: 8px 12px;
  font-size: 12px;
  font-weight: 700;
  background: var(--color-yellow);
  color: var(--color-ink-solid);
`;

const Ghost = styled.button`
  background: none;
  border: none;
  color: var(--ink-soft);
  font-size: 12px;
  font-weight: 600;
  padding: 4px;
`;
